import { create, METHOD } from '../utils'

export default {
    list: create({
        url: "/egg/remind/list",
        method: METHOD.GET
    }),
    add: create({
        url: "/egg/remind/add",
        method: METHOD.POST
    }),
    put: create({
        url: "/egg/remind/put",
        method: METHOD.PUT
    }),
    del: create({
        url: "/egg/remind/del",
        method: METHOD.DELETE
    }),
}